/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Type_WeightInputs */

const fr_load_type_weight = /** @type {(inputs: Load_Type_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids`)
};

/**

* @param {Load_Type_WeightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const load_type_weight = /** @type {((inputs?: Load_Type_WeightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Type_WeightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_load_type_weight(inputs)
});